import { createV3Queries } from "@query/utils/createV3Queries";
import { transfersApi } from "@api";
import { queriesInternalAccounts } from "./queriesInternalAccounts";

export const queriesTransfers = createV3Queries("transfersApi", transfersApi, {
  // A transfer moves money in/out of an internal account, so it must refresh the
  // internal-account balance and the transactions list — cross-resource deps the
  // name-derived defaults can't infer. `queriesInternalAccounts` is defined first,
  // so we close over its keys.
  createTransfer: () => ({
    dependencies: () => [
      queriesInternalAccounts.getInternalAccountBalance.queryKeyBase,
      queriesInternalAccounts.listInternalAccountTransactions.queryKeyBase
    ]
  })
});
